import { types } from "./types";
import ExportExcel from "./ExportExcel/ExportExcel";
import Read from "./Read/Read";

function Actions(
  action,
  showAlert,
  variables,
  setOpenVariable,
  variableRender
) {
  switch (action.actionName) {
    case types.EXPORTEXCEL:
      return (
        <ExportExcel
          action={action}
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
        />
      );
    case types.READ:
      return (
        <Read
          action={action}
          showAlert={showAlert}
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
        />
      );
    default: break;
  }
}

export default Actions;
